module.exports = __webpack_public_path__ + "static/media/ovgu.71a136dd.svg";